export interface PasswordToggleState {
  type: 'text' | 'password'
  action: 'show' | 'hide'
  pressed: boolean
}

/** The button names the action it will take, and is pressed while the password is readable. */
export function passwordToggle(shown: boolean): PasswordToggleState {
  return shown ? { type: 'text', action: 'hide', pressed: true } : { type: 'password', action: 'show', pressed: false }
}
